const CALCULATOR = {
  desktopHeight: 1000,
};
export default CALCULATOR;



// WEBPACK FOOTER //
// ./src/common/consts/calculator.js